<template>
	<div
		class="position-relative q-form-field dropdown-selection"
		:class="$props.class"
	>
		<QFormFieldViewWrapper
			ref="viewWrapper"
			:disabled="disabled"
			:placement="placement"
			:teleport-to="teleportTo"
			:input-element="inputElement"
			custom-popover-class="dropdown-selection-wrapper no-print"
			:custom-modal-class="['dropdown-selection-modal', customModalClass]"
			:modal-breakpoint="modalBreakpoint"
			@clicked-outside="onClickedOutside"
		>
			<template #field>
				<slot />
				<QFormFieldWrapper
					ref="wrapper"
					v-model="selectedValue"
					:size="size"
					:name="name"
					@click.stop="onClickWrapper"
				>
					<template #default="defaultSlotProps">
						<input
							ref="inputElement"
							v-bind="defaultSlotProps.field"
							:value="inputValue"
							:placeholder="placeholder"
							class="form-control"
							:class="[
								{
									['form-control-' + size]: true,
									'is-valid': defaultSlotProps.state === true,
									'is-invalid': defaultSlotProps.state === false
								},
								defaultSlotProps.class
							]"
							:disabled="disabled"
							readonly
							@blur="onBlur"
							@focus="onFocus"
							@copy.prevent
							@paste.prevent
						>
					</template>
					<template #appendIcon>
						<i
							v-if="!hideIcon"
							:class="inputClass"
							aria-hidden="true"
						/>
					</template>
				</QFormFieldWrapper>
			</template>

			<template #content>
				<div
					ref="popoverContent"
					class="dropdown-selection-body"
					@click.stop
				>
					<q-overlay
						:show="helpers.loading || loading"
						:size="spinnerSize"
						no-wrap
					>
						<slot name="popover-header" />
						<div class="options-wrapper">
							<template
								v-for="(option, index) in options"
								:key="index"
							>
								<div
									v-if="!Boolean(option.href)"
									:class="{ 'disabled': option.isDisabled, 'selected': selectedValue === option }"
									class="options-wrapper__element"
									:disabled="option.isDisabled"
									@click="onOptionClick(option)"
								>
									<span class="text">{{ option.text }}</span>
								</div>
								<q-link
									v-else
									:href="option.href"
									:class="{ 'disabled': option.isDisabled }"
									:disabled="option.isDisabled"
									class="options-wrapper__element border-bottom-0"
									@click="onOptionClick(option)"
								>
									<span class="text">{{ option.text }}</span>
									<i class="bi bi-box-arrow-up-right" />
								</q-link>
							</template>
						</div>
						<slot name="popover-footer" />
					</q-overlay>
				</div>
			</template>
		</QFormFieldViewWrapper>
	</div>
</template>
<script lang="ts" src="./dropdown-selection.ts"></script>
<style lang="scss" src="./dropdown-selection.scss"></style>
